const API_KEY = 'AIzaSyBD4g62CeBHNKzNHhpF11nKTyI8HuhLbUk';

/* --- Catalog: categories -> mowers -> video IDs --- */
const catalog = {
  homeowner: {
    label: 'Homeowner',
    mowers: {
      buckingham:  { label: 'Buckingham', ids: ['3FhJm951Qhg','6dhw6YI2BuU','i2ELzNNKpyI','pxUqENOnx3A'] },
      cambridge:   { label: 'Cambridge',  ids: ['NdpkBmgd3yo','1pS8EHo4hUk','3uQEZZbWtd0','ROclJaTDNSk'] },
      cartridges:  { label: 'Cartridges/Other', ids: ['M4IARqiZVCQ','QpVHyjNQ7Ks'] },
      classic12e:  { label: 'Classic 12E / Sandringham 14E', ids: ['Xnb6v1ixc3w','bL823DBgmbE','vqmMKS0eF5I','O1Dz7lTdKiM','iPBIZrFlGTY','ywNENBKRJ-I','TlN2J0Kv4kM'] },
      classic14l:  { label: 'Classic 14L/17L', ids: ['7AWLeUbjXjs','j6Dg1-pTws4','vqmMKS0eF5I','9zL7e0YgKLg','dAPaqwls2DA','SVjr28CvgZo','yrziTDd-37A'] },
      kensington:  { label: 'Kensington', ids: ['07cGNUJRQqU','flpognbB_o0','qbbMxggnJ_0','vqmMKS0eF5I','yrziTDd-37A','7AWLeUbjXjs','FBglizscRm4','PbOCOUC1kfQ','ZB1kxQhyoIc','HpsyJnsBVyY','rjuhJuzaZsw','ROclJaTDNSk'] },
      liberty3035: { label: 'Liberty 30/35', ids: ['vqmMKS0eF5I','UcPxEtvkwh0','2CayNmlyak8','_6gtaRJnv5c','KbRasDuda5w','tUMnD01GsEM','O1Dz7lTdKiM'] },
      liberty43:   { label: 'Liberty 43', ids: ['uutWddISZns','ROclJaTDNSk','vqmMKS0eF5I','98xb9RGBeG4','SoHSZTpRCSk','mu0WLtrBMd8','wgndSjxiYzA','HpsyJnsBVyY','FBglizscRm4'] },
      Stirling:    { label: 'Stirling', ids: ['YqKYaK3FO8A','DdHZz4on-dY','6HVJiWFDY4w','Q3_2I4dtoqU','HpsyJnsBVyY','qwJOxN4qDFc','dhyONYhKZxM','ROclJaTDNSk'] },
    }
  },

  /* Sports Pro ranges */
  sportspro: {
    label: 'Sports Pro',
    mowers: {
      "C-Range": { label: 'C-Range', ids: ['WO2npH21GSQ','8-8bdNQ5UU8','TAJNbxb_KPk','bwX_YQTI-BU','_D9B6pGsfVM','b79Ur6UrMM4','45SuFxjqzXg','4Qlt86jDBF0'] },
      Buffalo:   { label: 'Buffalo',  ids: ['B7FJoJdUBAY','vSKg07rmeJk','7MkEf6IO6eo'] },
      Shaver:    { label: 'Shaver',   ids: [] },
      Tournament:{ label: 'Tournament', ids: [] },
      Regal:     { label: 'Regal',    ids: [] },
      Uplift:    { label: 'Uplift',   ids: [] },
    }
  }
};

let currentCategory = 'homeowner';

function setCategory(categoryKey, clickedButton) {
  currentCategory = categoryKey;

  document.querySelectorAll('.category-toggle button').forEach(b => {
    b.classList.remove('active');
    b.setAttribute('aria-selected', 'false');
  });
  clickedButton.classList.add('active');
  clickedButton.setAttribute('aria-selected', 'true');

  renderMowerButtons(categoryKey);

  const firstBtn = document.querySelector('#mower-buttons button');
  const results = document.getElementById('youtube-results');
  if (firstBtn) {
    firstBtn.click();
  } else {
    results.innerHTML = '<p>No mower ranges available for this category.</p>';
  }
}

function renderMowerButtons(categoryKey) {
  const wrap = document.getElementById('mower-buttons');
  wrap.innerHTML = '';

  const mowers = catalog[categoryKey]?.mowers || {};
  const keys = Object.keys(mowers);

  keys.forEach((key, idx) => {
    const btn = document.createElement('button');
    btn.textContent = mowers[key].label || key;
    btn.dataset.mowerKey = key;
    btn.onclick = function() { loadVideos(key, this); };

    if (categoryKey === 'homeowner' && idx === 0) btn.id = 'btn-buckingham';
    wrap.appendChild(btn);
  });
}

async function loadVideos(mowerKey, clickedButton) {
  const container = document.getElementById('youtube-results');
  container.innerHTML = '';

  document.querySelectorAll('#mower-buttons button').forEach(btn => btn.classList.remove('active'));
  clickedButton.classList.add('active');

  const videoIds = (catalog[currentCategory]?.mowers?.[mowerKey]?.ids) || [];
  if (videoIds.length === 0) {
    container.innerHTML = '<p>No videos available for this mower.</p>';
    return;
  }

  const apiUrl = `https://www.googleapis.com/youtube/v3/videos?part=snippet&id=${videoIds.join(',')}&key=${API_KEY}`;

  try {
    const response = await fetch(apiUrl);
    const data = await response.json();

    const gridWrapper = document.createElement('div');
    gridWrapper.className = 'video-grid';

    (data.items || []).forEach(item => {
      const videoId = item.id;
      const title = item.snippet.title;
      const thumbUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

      const card = document.createElement('div');
      card.className = 'video-card';
      card.onclick = () => openModal(videoId);

      const img = document.createElement('img');
      img.className = 'video-thumb';
      img.src = thumbUrl;
      img.alt = title;

      const caption = document.createElement('p');
      caption.className = 'video-title';
      caption.textContent = title;

      card.appendChild(img);
      card.appendChild(caption);
      gridWrapper.appendChild(card);
    });

    container.appendChild(gridWrapper);
  } catch (err) {
    console.error('YouTube API error:', err);
    container.innerHTML = '<p>Failed to load videos. Please try again later.</p>';
  }
}

function openModal(videoId) {
  const modal = document.getElementById('video-modal');
  const iframe = document.getElementById('modal-iframe');
  iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
  modal.classList.add('active');
}

function closeModal() {
  const modal = document.getElementById('video-modal');
  const iframe = document.getElementById('modal-iframe');
  iframe.src = '';
  modal.classList.remove('active');
}

function handleModalClick(event) {
  const modalContent = document.querySelector('.video-modal-content');
  if (!modalContent.contains(event.target)) closeModal();
}

window.onload = function () {
  renderMowerButtons(currentCategory);
  const firstBtn = document.querySelector('#mower-buttons button');
  if (firstBtn) firstBtn.click();
};
